export default __webpack_public_path__ + "static/media/oraculos.86e7dc34.jpg";